module.exports = __webpack_public_path__ + "assets/img/202109-5.c1773665.png";